import React, { useEffect } from "react";
import { Page, SubmitButton, FormGroup, DatePicker } from "components/common";
import { Control, actions } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import { isCurrency } from "services/util";
import { isInt } from "validator";
import BackButton from "components/refactoring/BackButton";

export const Edit = ({ t, model = "local", history, match, client }) => {
  const { id } = match.params;
  const { dispatch, setValue, Form, save, loaded } = useForm({
    model,
  });

  useEffect(() => {
    setValue({
      amount: "",
      num_months: "",
      description:"",
      date_of_funding:"",
      status:"Pending",
    });
  }, []);

  async function onSubmit(item) {
    item = {...item, status:"Pending"}
    try {
      await save(client, `employees/${id}/loans`, item);
      NotificationManager.success(t("Loan request has been sent"));
      history.replaceUp({ pathname: "../.." });
    } finally {
      dispatch(actions.setPending(model, false));
    }
  }

  if (!loaded) return null;

  return (
    <Page title="Request a Loan">
      <BackButton />
      <Form
        onSubmit={onSubmit}
        validators={{
          amount: isCurrency,
          num_months: (v) => isInt(v) && parseInt(v, 10) > 0,
        }}
      >
        <FormGroup label="Amount" model=".amount" className="my-2">
          <Control.text className="form-control" model=".amount" />
        </FormGroup>
        <FormGroup label="Number of months to pay over" model=".num_months" className="my-2">
          <Control.text className="form-control" model=".num_months" />
        </FormGroup>
        <FormGroup className="pb-3 text-nowrap" label="Date of Funding *" model=".date_of_funding">
          <DatePicker type="date" className="form-control" model=".date_of_funding"/>
        </FormGroup>
        <FormGroup label="Reason" model=".description" className="my-2">
          <Control.text className="form-control" model=".description" />
        </FormGroup>
        <div className="d-flex justify-content-end mt-3">
          <SubmitButton>Send Request</SubmitButton>
        </div>
      </Form>
    </Page>
  );
};

export default Edit;
